import React, { useCallback } from "react";

import TranslationTextField from "./TranslationTextField";

import { Grid, Chip } from "@mui/material";

let env = require("./../../../../env");

/***
 * translationValue = numberOfBagsInfo
 * language = "En"
 */
const TranslationTextElement = ({
  label,
  grouping,
  translationValue,
  replacementString,
  currentLanguageTab,
  currentTheme,
  //translations,
  onTranslationUpdate
}) => {
  const languageConfig = {
    en: { code: "En", label: "EN" },
    fr: { code: "Fr", label: "FR" }
  };

  const languages = ["en", "fr"];

  return languages.map(lang => {
    const config = languageConfig[lang];

    return (
      <React.Fragment key={lang}>
        <Grid
          item
          xs={6}
          style={{
            display: currentLanguageTab === config.code ? "block" : "none",
            alignContent: "center"
          }}
        >
          {label} {config.label}{" "}
          {grouping && (
            <Chip
              label={grouping}
              size="small"
              sx={{
                backgroundColor: "black",
                color: "white" // text color
              }}
            />
          )}
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            display: currentLanguageTab === config.code ? "block" : "none",
            alignContent: "center"
          }}
        >
          <TranslationTextField
            translationValue={translationValue}
            language={config.code}
            value={currentTheme.translations?.[translationValue]?.[config.code]}
            replacementString={replacementString}
            //value={"TEST"}
            onTranslationUpdate={onTranslationUpdate}
          />
        </Grid>
      </React.Fragment>
    );
  });

  //////////////////////////////////
};

export default TranslationTextElement;
